import React, { Component, Fragment } from 'react';

export default class Image extends Component {
  render() {
    return <img className="img-responsive" alt={this.props.alt} src={this.props.src} style={this.props.style} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Image.jsx